export function partition<T>(
  array: T[],
  predicate: (item: T) => boolean
): [T[], T[]] {
  return array.reduce(
    (acc, item) => {
      acc[predicate(item) ? 0 : 1].push(item);
      return acc;
    },
    [[], []] as [T[], T[]]
  );
}

export function randomBetween(min: number, max: number): number {
  return Math.random() * (max - min) + min;
}

export function uniqueCountBy<T>(
  array: T[],
  key: (item: T) => string | undefined
): number {
  const seen = new Set<string>();
  for (const item of array) {
    const keyValue = key(item);
    if (keyValue) {
      seen.add(keyValue);
    }
  }
  return seen.size;
}

export function count<T>(items: T[], predicate?: (item: T) => boolean): number {
  if (!predicate) return items.length;
  return items.reduce((n, item) => predicate(item) ? n + 1 : n, 0);
}